
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"9","height":"5","viewBox":"0 0 9 5","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.75974 0.203872L4.5 3.13528L1.24026 0.203941C0.957482 -0.0669798 0.497936 -0.0680183 0.21382 0.201622C-0.0703695 0.471297 -0.071349 0.909532 0.211353 1.18042L3.98624 4.79738C4.26996 5.0684 4.73168 5.06691 5.01445 4.79668L8.78865 1.18035C9.07139 0.909428 9.07033 0.471193 8.78618 0.201553C8.50206 -0.0680871 8.04252 -0.0670491 7.75974 0.203872Z"}})])
          )
        }
      }
    